module.exports = __webpack_public_path__ + "img/cone.74fb93d.svg";